export enum SolverStatus {
  STARTED = "STARTED",
  RUNNING = "RUNNING",
  SLEEPING = "SLEEPING",
  STOPPING = "STOPPING",
  STOPPED = "STOPPED"
}
